import React from 'react';
import { useTranslation } from "react-i18next";

const CLMCrads = () => {
  const { t } = useTranslation("translation");

  const useCases = [
    {
      id: 1,
      team: t("useCases.realEstateTitle"),
      description: t("useCases.realEstateDesc"),
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <rect x="10" y="21" width="20" height="9" rx="2" stroke="#60a5fa" strokeWidth="2.5"/>
          <path d="M8 23L20 12L32 23" stroke="#60a5fa" strokeWidth="2.5" strokeLinecap="round"/>
          <rect x="19" y="26" width="2" height="4" rx="1" fill="#60a5fa"/>
        </svg>
      )
    },
    {
      id: 2,
      team: t("useCases.legalTitle"),
      description: t("useCases.legalDesc"),
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M20 3L8 10V18C8 26 14 33 20 37C26 33 32 26 32 18V10L20 3Z" stroke="#8c8efa" strokeWidth="2.5"/>
          <path d="M15 20L18 23L25 16" stroke="#8c8efa" strokeWidth="2.5"/>
        </svg>
      )
    },
    {
      id: 3,
      team: t("useCases.salesTitle"),
      description: t("useCases.salesDesc"),
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M10 15L15 10L20 15L25 10L30 15" stroke="#f46958" strokeWidth="2.5"/>
          <path d="M30 15V25C30 27.2091 28.2091 29 26 29H14C11.7909 29 10 27.2091 10 25V15" stroke="#f46958" strokeWidth="2.5"/>
          <circle cx="20" cy="22" r="3" stroke="#f46958" strokeWidth="2.5"/>
        </svg>
      )
    },
    {
      id: 4,
      team: t("useCases.financeTitle"),
      description: t("useCases.financeDesc"),
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M8 12H32M8 20H32M8 28H32" stroke="#13c0be" strokeWidth="2.5"/>
          <rect x="12" y="8" width="16" height="24" rx="2" stroke="#13c0be" strokeWidth="2.5"/>
          <path d="M16 16H24M16 20H24M16 24H20" stroke="#13c0be" strokeWidth="2"/>
        </svg>
      )
    },
    {
      id: 5,
      team: t("useCases.procurementTitle"),
      description: t("useCases.procurementDesc"),
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <path d="M14 18C14 15.7909 15.7909 14 18 14H22C24.2091 14 26 15.7909 26 18V18C26 20.2091 24.2091 22 22 22H18C15.7909 22 14 20.2091 14 22V22C14 24.2091 15.7909 26 18 26H22C24.2091 26 26 24.2091 26 22" stroke="#ffbc41" strokeWidth="2.5"/>
          <circle cx="20" cy="20" r="12" stroke="#ffbc41" strokeWidth="2.5"/>
        </svg>
      )
    },
    {
      id: 6,
      team: t("useCases.hrTitle"),
      description: t("useCases.hrDesc"),
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
          <circle cx="20" cy="13" r="5" stroke="#9c48f5" strokeWidth="2.5"/>
          <path d="M12 32C12 27.5817 15.5817 24 20 24C24.4183 24 28 27.5817 28 32" stroke="#9c48f5" strokeWidth="2.5"/>
          <circle cx="10" cy="15" r="3" stroke="#9c48f5" strokeWidth="2"/>
          <circle cx="30" cy="15" r="3" stroke="#9c48f5" strokeWidth="2"/>
          <path d="M6 30C6 27.2386 8.23858 25 11 25" stroke="#9c48f5" strokeWidth="2"/>
          <path d="M34 30C34 27.2386 31.7614 25 29 25" stroke="#9c48f5" strokeWidth="2"/>
        </svg>
      )
    }
  ];

  return (
    <section className="use-cases-section">
      <div className="guest-container">
        
        <div className="use-cases-header">
          <h2 className="use-cases-main-title">
            {t("useCases.mainTitle")}
          </h2>
        </div>

        <div className="use-cases-grid">
          {useCases.map((useCase) => (
            <div key={useCase.id} className="use-case-card">
              <div className="card-inner">
                <div className="use-case-icon-wrapper">
                  <div className="use-case-icon">
                    {useCase.icon}
                  </div>
                </div>

                <h3 className="use-case-team">{useCase.team}</h3>
                <p className="use-case-description">{useCase.description}</p>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CLMCrads;
